import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonComponent } from 'ui-component/src/public-api';

@Component({
  selector: 'app-payment-link-created-dialog',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './payment-link-created-dialog.component.html',
  styleUrl: './payment-link-created-dialog.component.scss',
})
export class PaymentLinkCreatedDialogComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);

  linkUrl: string = this.config.data?.linkUrl || '';
  copySuccess = false;

  copyLink(): void {
    navigator.clipboard.writeText(this.linkUrl).then(() => {
      this.copySuccess = true;
      setTimeout(() => {
        this.copySuccess = false;
      }, 2000);
    });
  }

  close(): void {
    this.ref.close();
  }
}
